// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1y1_s","productName":"Table_productName__CA_AL"};